/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioMicAIcon16Regular = forwardRef('MediaAudioMicAIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a3 3 0 0 0-3 3v4a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3ZM6.5 4a1.5 1.5 0 1 1 3 0v4a1.5 1.5 0 1 1-3 0V4Z" }),
        React.createElement("path", { d: "M3.25 6a.75.75 0 0 1 .75.75V8a4 4 0 0 0 8 0V6.75a.75.75 0 0 1 1.5 0V8a5.501 5.501 0 0 1-4.75 5.45v1.05h1.75a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5h1.75v-1.05A5.501 5.501 0 0 1 2.5 8V6.75A.75.75 0 0 1 3.25 6Z" })));
});
